// проверка на отсутствие пробелов, символов и цифр в первом введенном значении
export const onlyLetters = /^[а-яА-Яa-zA-Z]/;
